// common configuration
const config = {
    api: {
        baseUrl: "https://app.salesman.digitalwish.cz/api"
    },
    afterLoginRoute: "companies",
    vueAppUrl: "https://app.salesman.digitalwish.cz",
    MAX_FILE_SIZE_MB: 104857600, // Maximum file size is 100MB
    startDateForStats: new Date("2025-02-01").getTime() // Default start date for statistics
};

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    config["vueAppUrl"] = "http://localhost:10201";
    config["api"]["baseUrl"] = "http://localhost:10200";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_tomas") {
    config["vueAppUrl"] = "http://localhost:36001";
    config["api"]["baseUrl"] = "http://localhost:36000";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_kuba") {
    config["vueAppUrl"] = "http://localhost:20001";
    config["api"]["baseUrl"] = "http://localhost:20000";
    config.startDateForStats = new Date("2025-01-25").getTime();
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "staging") {
    config["vueAppUrl"] = "https://app.staging.salesman.digitalwish.cz";
    config["api"]["baseUrl"] = "https://app.staging.salesman.digitalwish.cz/api";
    config.startDateForStats = new Date("2025-01-25").getTime();
}

export const CONFIG = config;